var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"flex":"1"},attrs:{"type":"text"},on:{"click":function($event){return _vm.issue()}}},[_vm._v("I")])
}
var staticRenderFns = []

export { render, staticRenderFns }